import React from "react";
import { useStore } from "../context/StoreContext"; // ✅ Get products from store
import Products from "../components/Products";
import "./styles/ViewAllProducts.css";
import test from './../assets/endKnife2.webp';
import { getImageUrl } from "../utility/imageHelper";
import SEO from "../seo/SEO";
import config from "../config/config";
import generateBreadcrumbs from "../utility/generateBreadcrumbs";
import { slugify } from "../utility/slugify";

const ViewAllProducts = () => {
  const { products } = useStore(); // ✅ Get all products

  return (

    <>
    
        <SEO
            title="Shop All Knives - Withrow Knives"
            description="Browse our full collection of custom handmade knives. Premium quality blades and custom leather sheaths crafted with expert precision."
            keywords={[
                "custom knives",
                "handmade knives",
                "premium knives",
                "hunting knives",
                "survival knives",
                "Withrow Knives"
            ]}
            url={`${config.metadata.siteUrl}/shop/all-products`}
            jsonLd={{
              "@context": "https://schema.org",
              "@type": "ItemList",
              "name": "Shop All Knives - Withrow Knives",
              "url": `${config.metadata.siteUrl}/shop-knives/all-knives`,
              "description": "A collection of all custom handmade knives available at Withrow Knives.",
              "numberOfItems": products.length,
              "itemListElement": products.map((product, index) => ({
                  "@type": "ListItem",
                  "position": index + 1,
                  "name": product.name,
                  "url": `${config.metadata.siteUrl}/shop-knives/knife/${product.id}/${slugify(product.name)}`,
                  "image": product.images ? product.images.map(img => getImageUrl(img)) : [],
                  "offers": {
                      "@type": "Offer",
                      "priceCurrency": "USD",
                      "price": product.price,
                      "availability": product.stock > 0 ? "https://schema.org/InStock" : "https://schema.org/OutOfStock",
                      "seller": {
                          "@type": "Organization",
                          "name": "Withrow Knives"
                      }
                  }
              })),
              "breadcrumb": generateBreadcrumbs(["shop-knives", "all-knives"])
          }}
        />

      <div className="page-wrapper">
        {/* ✅ Page Content */}
        <div className="page-title" style={{ backgroundImage: `url(${test})`, backgroundSize: "cover", backgroundPosition: "50% 30%" }}>
          <h1>All Products</h1>
          <p className="page-subtitle">Browse our complete collection of custom handmade knives.</p>
        </div>
        <section aria-labelledby="all-products-title">
          <h2 id="all-products-title" className="sr-only">All Products</h2>
          <Products products={products} listName="All Products" fireListViewEvent={true}/>
        </section>
      </div>
    </>
  );
};

export default ViewAllProducts;
